import { authClient } from './AuthClient';

const leadingSlashPattern = /^\/?/;
const traillingSlashPattern = /\/?(\?|#|$)/;
const formatRoute = (route: string) =>
  route.replace(leadingSlashPattern, '').replace(traillingSlashPattern, '/$1');

export const get = (route: string) => authClient.get(formatRoute(route));
export const patch = (route: string, params?: unknown) =>
  authClient.patch(formatRoute(route), { json: params });
export const put = (route: string, params?: unknown) =>
  authClient.put(formatRoute(route), { json: params });
export const post = (route: string, params?: unknown) =>
  authClient.post(formatRoute(route), { json: params });
export const del = (route: string) => authClient.delete(formatRoute(route));

export const getJson = async (route: string) => {
  const response = await get(route);
  return response.json();
};

export const patchJson = async (route: string, params: unknown) => {
  const response = await patch(route, params);
  return response.json();
};

export const postJson = async (route: string, params: unknown) => {
  const response = await post(route, params);
  if (response.status === 204) return undefined;
  return response.json();
};
